var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3f373f",
    id: "arrow-down-a",
    d: "M65.5548531,26.9747794 L37.9372612,54.5548531 C37.4661988,55.0259154 36.907594,55.2614465 36.2614465,55.2614465 C35.6152991,55.2614465 35.0566942,55.0259154 34.5856319,54.5548531 L6.96804002,26.9747794 C6.4969777,26.5037171 6.26144654,25.9388592 6.26144654,25.2802057 C6.26144654,24.6215521 6.4969777,24.0566942 6.96804002,23.5856319 L13.1460432,17.4451469 C13.6171055,16.9740846 14.1757104,16.7385535 14.8218578,16.7385535 C15.4680053,16.7385535 16.0266102,16.9740846 16.4976725,17.4451469 L36.2614465,37.208921 L56.0252206,17.4451469 C56.4962829,16.9740846 57.0548878,16.7385535 57.7010352,16.7385535 C58.3471827,16.7385535 58.9057875,16.9740846 59.3768499,17.4451469 L65.5548531,23.5856319 C66.0259154,24.0566942 66.2614465,24.6215521 66.2614465,25.2802057 C66.2614465,25.9388592 66.0259154,26.5037171 65.5548531,26.9747794 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrow-down-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.48693a2c40e7d7ed9478ccd1ae74fa55.svg";